module.exports = __webpack_public_path__ + "img/SKLB-Ronda.afbf51e9.png";